import { useEffect, useState } from 'react'
import ModalComponent from '..'
import { PRIMARY_COLOR } from '../../../constants'
import { useGetSubCategoriesQuery } from '../../../redux-toolkits/products/products.slice'
import { SingleSubCategory } from '../../../redux-toolkits/products/products.type'
import {
  QueryProps,
  StorefrontSection,
} from '../../../redux-toolkits/shared/shared.type'
import { Button } from '../../button'
import { EmptyState } from '../../emptyState/emptyState'
import { Checkbox } from '../../inputs/Checkbox'
import { SearchInput } from '../../inputs/searchInput'
import { LoadingOval } from '../../spinner/Spinner'

const defaultquery = {
  search: undefined,
  skip: 0,
  limit: '100',
}

export const SelectSubCategoriesModal = ({
  open,
  setOpen,
  onCloseCallback,
  onSuccessCallback,
  selectedSubCategories = [],
  categories = [],
  maxSelection,
  activeOnly = false,
  section,
}: {
  open: boolean
  setOpen: (val: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: (val: SingleSubCategory[]) => void
  selectedSubCategories?: SingleSubCategory[]
  categories?: string[]
  maxSelection?: number
  activeOnly?: boolean
  section?: StorefrontSection
}) => {
  const [queryParam, setQueryParam] = useState<QueryProps>(defaultquery)

  const [subCategories, setSubCategories] = useState<SingleSubCategory[]>([])

  const { data, isFetching } = useGetSubCategoriesQuery(
    {
      ...queryParam,
      categories: categories.length > 0 ? categories.join(',') : undefined,
      isAdmin: !activeOnly,
      section,
    },
    {
      skip: !open,
    },
  )

  useEffect(() => {
    if (open) {
      setSubCategories(selectedSubCategories)
    }
  }, [open])

  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        onCloseCallback && onCloseCallback()
        setQueryParam(defaultquery)
        setSubCategories(selectedSubCategories)
      }}
      title="Select Sub-Categories"
      childrenClassName="md:!max-w-[420px]"
    >
      <div
        className="
        h-screen max-h-[500px]
        flex flex-col gap-4
      "
      >
        <SearchInput
          searchFunction={(search) => {
            setQueryParam({
              ...queryParam,
              search: search === '' ? undefined : search,
              skip: 0,
            })
          }}
          placeholder="Search sub-categories"
          className="!max-w-full"
        />

        {/* Sub-Categories  */}
        <div className="flex-1 overflow-y-scroll">
          {isFetching ? (
            <div className="w-full flex justify-center pt-10">
              <LoadingOval
                loaderWidth="25"
                loaderHeight="25"
                color={PRIMARY_COLOR}
              />
            </div>
          ) : (
            <div>
              {data?.data?.result?.length && data?.data?.result?.length > 0 ? (
                <div className="flex flex-col">
                  {data?.data?.result
                    ?.filter(
                      (subCategory) =>
                        !activeOnly ||
                        subCategory.isActive ||
                        subCategories
                          .map((selected) => selected._id)
                          .includes(subCategory._id),
                    )
                    .map((subCategory, idx) => {
                      const key = `sub-category-selection-option-${idx}-${subCategory._id}`
                      return (
                        <Checkbox
                          disabled={
                            maxSelection !== undefined &&
                            subCategories.length >= maxSelection &&
                            !subCategories
                              .map((c) => c._id)
                              .includes(subCategory._id)
                          }
                          checkStatus={subCategories
                            .map((subCategory) => subCategory._id)
                            .includes(subCategory._id)}
                          handleChange={(checked) => {
                            if (checked) {
                              const subCategoriesCopy: SingleSubCategory[] =
                                JSON.parse(JSON.stringify(subCategories))
                              subCategoriesCopy.push(subCategory)

                              setSubCategories(subCategoriesCopy)
                            } else {
                              const subCategoriesCopy: SingleSubCategory[] =
                                JSON.parse(JSON.stringify(subCategories))
                              setSubCategories(
                                subCategoriesCopy.filter(
                                  (singleSubCategory) =>
                                    singleSubCategory._id !== subCategory._id,
                                ),
                              )
                            }
                          }}
                          text={
                            <div className="text-xs">
                              <p className="text-base font-medium">
                                {subCategory.name}
                              </p>

                              <p>Category: {subCategory.category.name}</p>
                              <p>
                                Parent sub-category:{' '}
                                {subCategory?.parentSubcategory?.name ?? 'N/A'}
                              </p>
                            </div>
                          }
                          textPosition="right"
                          className="
                        py-3 border-b last:border-b-0
                        w-full
                        "
                          key={subCategory._id}
                        />
                      )
                    })}
                </div>
              ) : (
                <EmptyState text="No sub-categories found" />
              )}
            </div>
          )}
        </div>

        <Button
          type="button"
          primary
          label="Continue"
          onClick={() => {
            onSuccessCallback && onSuccessCallback(subCategories)
          }}
          className="sticky bottom-0"
        />
      </div>
    </ModalComponent>
  )
}
